/* eslint-disable react/jsx-props-no-spreading */
import React, { useState } from 'react';
import { useGetUserPermissionsIdsQuery } from '../../services/user-permissions.service';
import { useGetITAMembershipsQuery } from '../../services/memberships.service';
import SelectTypeAhead, { normalizeOptionValue } from '../../components/form-elements/select-type-ahead';

interface Props {
  hidden?: boolean,
  disabled?: boolean,
  user: {label: string, value: string},
  onAssignmentChange(userID: string | undefined): void,
  label: string,
  apiToken?: string,
  objectId?: any,
  requestType: string,
  hasValidationError?: boolean,
  helperText?: string,
  unassignOption?: {label: string, value: string};
}

const ITAAssignmentField: React.FC<Props> = ({
  hidden = false,
  disabled = false,
  user,
  onAssignmentChange,
  label,
  apiToken,
  objectId,
  requestType,
  hasValidationError,
  helperText,
  unassignOption,
}: Props) => {
  const [selected, setSelected] = useState(normalizeOptionValue(user));
  const [search, setSearch] = useState('');

  const { data: userPermissions } = useGetUserPermissionsIdsQuery({
    apiToken, objectId, requestType,
  });

  const { data: memberships, isError, isFetching } = useGetITAMembershipsQuery({
    search,
    transform: true,
    permissions: userPermissions,
  });
  // @ts-ignore
  const memberOptions = unassignOption && memberships ? [unassignOption, ...memberships] : memberships;
  const findUser = (id: string) => memberships?.find((member) => member.value === id);

  const handleSelectChange = (option) => {
    setSelected(option);
    if (option === unassignOption) {
      onAssignmentChange(option.value);
    } else {
      const userToSelect = option ? findUser(option.value) : { label: '', value: '' };
      onAssignmentChange(userToSelect.value);
    }
  };

  return (
    <SelectTypeAhead
      hidden={hidden}
      label={label}
      hasValidationError={hasValidationError}
      helperText={helperText}
      isError={isError}
      errorResource="members"
      // @ts-ignore
      options={memberOptions}
      onSetFilter={setSearch}
      loadingText="Loading Members..."
      loading={isFetching}
      disabled={disabled}
      value={selected}
      onClose={() => setSearch('')}
      onChange={(evt, option) => handleSelectChange(option)}
      isOptionEqualToValue={(option, value) => option.value === value?.value}
      filterOptions={(options) => options}
    />
  );
};

export default ITAAssignmentField;
